import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 600;\n  font-style: italic;\n  color: #fff;\n  margin-right: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 18px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 100px;\n  display: flex;\n  height: 20px;\n  justify-content: space-between;\n  opacity: ", ";\n  padding: 13px 5px 13px 10px;\n  transition: opacity 300ms ease-in-out;\n  position: absolute;\n  right: 60px;\n\n  @media screen and (max-width: ", "px) {\n    right: 30px;\n  }\n  @media screen and (max-width: ", "px) {\n    right: 20px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import CheckHollowURL from '../assets/icons/white-check-hollow.svg';
import styled from '../utils/styling/styled-components';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.green;
}, function (props) {
  return props.show ? '1' : '0';
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.sm;
});
var Check = styled.img(_templateObject2());
var Text = styled.span(_templateObject3());

var SavedLabel = function SavedLabel(_ref) {
  var show = _ref.show,
      text = _ref.text,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    show: show,
    className: className
  }, /*#__PURE__*/React.createElement(Text, null, text), /*#__PURE__*/React.createElement(Check, {
    src: CheckHollowURL,
    alt: ""
  }));
};

export { SavedLabel };